














import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import { ModuleName } from '@getaccept/lib-shared/src/entity/app-modules/enums/app-module';
import GetAcceptLogo from '@getaccept/lib-ui/src/assets/img/getaccept-logo-blue-text.svg';
import PulseContractsIcon from '../assets/pulse-contracts.svg';
import PulseRoomIcon from '../assets/pulse-room.svg';

export default defineComponent({
  name: 'LoadProductScreen',
  components: {
    PulseContractsIcon,
    PulseRoomIcon,
    GetAcceptLogo,
  },
  props: {
    activeModule: { type: String as PropType<ModuleName>, required: true },
  },
  setup(props) {
    const isDsr = computed(() => props.activeModule === ModuleName.DealRooms);

    return { ModuleName, isDsr };
  },
});
